import React from 'react';

interface ActionLinkButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  actionName?: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'blue';
  className?: string;
}

const ActionLinkButton: React.FC<ActionLinkButtonProps> = ({ 
  text, 
  onClick, 
  disabled = false, 
  actionName = 'Action Link Button',
  icon,
  variant = 'blue',
  className = ''
}) => {
  const baseClasses = "font-light transition duration-300 underline flex items-center space-x-2 text-xs";
  const variantClasses = variant === 'blue' 
    ? 'text-blue-600 hover:text-blue-700' 
    : 'text-gray-700 hover:text-gray-900';
  const disabledClasses = disabled ? 'cursor-default opacity-50' : 'cursor-pointer';

  return (
    <button
      onClick={(e) => { 
        e.stopPropagation(); 
        if (!disabled) onClick(); 
      }} 
      disabled={disabled}
      className={`${baseClasses} ${variantClasses} ${disabledClasses} ${className}`}
      data-dd-action-name={actionName}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      <span>{text}</span>
    </button>
  );
};

export default ActionLinkButton;
